import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import * as UsuarioCrud from 'services/usuario.service'

const UsuarioRecibeFormGroup = ({ vIdOficinaSolicitante, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [usuarios, setUsuarios] = React.useState([])

  React.useEffect(() => {
    if (vIdOficinaSolicitante) {
      UsuarioCrud.obtenerTodoAsSelect(vIdOficinaSolicitante)
        .then(({ data }) => setUsuarios(data))
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setUsuarios([])
    }
  }, [__zariContext, vIdOficinaSolicitante])

  return (
    <Form.Group>
      <Form.Label text='USUARIO QUE RECIBE' htmlFor='select-usuariorecibe' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idUsuarioRecibe'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting || !vIdOficinaSolicitante}
              id='select-usuariorecibe'
            >
              <option value=''>Seleccionar</option>
              {usuarios.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombres?.toUpperCase()} {val.apellidos?.toUpperCase()}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsuarioRecibeFormGroup)
